import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationDA from './locales/da/translation.json';
import translationEN from './locales/en/translation.json';

const resources = {
  da: {
    translation: translationDA
  },
  en: {
    translation: translationEN
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'da',
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
